module.exports = __webpack_public_path__ + "static/media/fvs_valve1_45.f99991bc.jpg";